import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3008';

const axiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 30000, // 30 seconds timeout
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true // Enable credentials - server now properly configured
});

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Set longer timeout for file uploads
        if (config.data instanceof FormData) {
            config.timeout = 60000; // 60 seconds for file uploads
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            // Handle specific error cases
            switch (error.response.status) {
                case 401:
                    // Unauthorized - clear token and redirect to login
                    localStorage.removeItem('token');
                    localStorage.removeItem('user_sis');
                    window.location.href = '/login';
                    break;
                case 403:
                    // Forbidden - user doesn't have permission
                    console.error('Access forbidden');
                    break;
                case 404:
                    // Not found
                    console.error('Resource not found');
                    break;
                case 500:
                    // Server error
                    console.error('Server error');
                    break;
                default:
                    console.error('An error occurred');
            }
        } else if (error.request) {
            // Network error - server not running
            console.error('Network error - server may not be running on localhost:3008');
            // Don't redirect to login on network errors, just show error
        } else if (error.code === 'ECONNABORTED') {
            // Timeout error
            console.error('Request timeout - the request took too long to complete');
        } else {
            // Other error
            console.error('Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance; 